import { useImperativeHandle, forwardRef, useEffect, useRef } from "react"
import styles from './index.module.scss'
import { notification } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const BottomEventPopup = forwardRef((props, ref) => {
    const [api, contextHolder] = notification.useNotification();
    const notificationKey = 'bottomEventPopup';
    const location = useLocation();
    const closeStateRef = useRef({
        hasCountedClose: false,
        skipNextOnClose: false,
        onClose: null
    });

    useImperativeHandle(ref, () => ({
        handleClick
    }))
    useEffect(() => {
        closeStateRef.current.skipNextOnClose = true;
        closeStateRef.current.hasCountedClose = false;
        closeStateRef.current.onClose = null;
        api.destroy(notificationKey);
    }, [location.pathname]);

    const handleClick = (popup, onClose) => {
        closeStateRef.current = {
            hasCountedClose: false,
            skipNextOnClose: false,
            onClose
        };

        const countCloseOnce = () => {
            if (!closeStateRef.current.hasCountedClose && closeStateRef.current.onClose) {
                closeStateRef.current.hasCountedClose = true;
                closeStateRef.current.onClose();
            }
        };

        api.info({
            key: notificationKey,
            message: null,
            description: (
                <div
                    onClick={() => {
                        props.popupClick(popup);
                        countCloseOnce();
                        api.destroy(notificationKey);
                    }}
                    className={styles.bottomEventPopupBox}
                >
                    <img src={popup?.popupImage} alt="" />
                </div>
            ),
            placement: 'bottomRight',
            closeIcon: (
                <span className={styles.modalcloseIcon}>
                    <CloseOutlined />
                </span>
            ),
            icon: <></>,
            duration: null,
            className: `${styles.bottomEventPopup} bottom-event-popup`,
            onClose: () => {
                if (closeStateRef.current.skipNextOnClose) {
                    closeStateRef.current.skipNextOnClose = false;
                    closeStateRef.current.onClose = null;
                    return;
                }

                countCloseOnce();
                closeStateRef.current.onClose = null;
            }
        });
    };

    return (
        <>
            {contextHolder}
        </>
    )
})

export default BottomEventPopup
